<template>
  <div>
    <div id="jxcelContainer">
      <!--   <v-layout>
        <tr>
          <td>
            <v-text-field
              v-model="recherche"
              type="text"
              label="Recherche"
              clearable
            ></v-text-field>
          </td>
        </tr>
      </v-layout> -->
      <div :key="keyContainer" ref="spreadsheet"></div>
    </div>
    <v-layout>
      <v-layout>
        <v-btn class="mr-2 scdf-yellow" @click="undo"
          ><v-icon>undo</v-icon>Annuler</v-btn
        >
        <v-btn class="mr-2 scdf-yellow" @click="redo">
          <v-icon>redo</v-icon>Rétablir</v-btn
        >
      </v-layout>
      <v-btn
        :disabled="!allValueFill"
        class="mr-2 scdf-green fix-btn-margin-top"
        @click="sendData(spreadsheet.getData())"
      >
        APPLIQUER LES MODIFICATIONS
      </v-btn>
      <v-btn
        :disabled="allowDelteAllContraints == 0"
        class="scdf-dark-red fix-btn-margin-top"
        @click="openModal"
        >Supprimer toutes les lignes</v-btn
      >

      <ConfirmPopup v-bind:show="showModal" @close="responseModal" />
    </v-layout>
  </div>
</template>
<script>
import jexcel from 'jexcel';
import 'jexcel/dist/jexcel.css';
import ConfirmPopup from '@/components/modal/ConfirmDeleteContrainsJexcel';

export default {
  components: { ConfirmPopup },
  props: ['user', 'widthJexcel', 'heightJexcel', 'dataSet', 'conf'],
  data: function () {
    return {
      allowDelteAllContraints: 0,
      showModal: false,
      recherche: '',
      el: null,
      spreadsheet: null,
      keyContainer: 0,
      modeInsert: '',
      rowChanges: {
        modificationType: '',
        values: [],
      },
      initialValues: [],
      modifRecords: [],
      newColumn: 0,
      structureData: {
        code: [],
        valeur: [],
        id: [],
      },
      allValueFill: true,
      columnCount: 0,
      contraintes: null,
      codeOrder: null,
      sources: this.dataSet.sources,
      options: {
        filters: true,
        data: null,
        columns: this.dataSet.columns,
        onselection: this.onSelection,
        onafterchanges: this.onAfterChanges,
        onchange: this.onChange,
        allowInsertColumn: false,
        ondeleterow: this.onDeleteRow,
        onpaste: this.onPaste,
        allowDeleteRow: null,
        allowInsertRow: null,
        onbeforeinsertrow: this.onBeforeInsertRow,
        oninsertrow: this.onInsertRow,
        contextMenu: this.contextMenuCustom,
        tableOverflow: true,
        fullscreen: false,
        tableWidth: null,
        tableHeight: null,
        style: {},
      },
    };
  },
  methods: {
    keepInitialRows: function () {
      this.spreadsheet.getData().forEach((data) => {
        let obj = new Object();
        obj.code = {};
        obj.valeur = {};
        obj.id = {};
        obj.row = [];
        for (var j = 0; j < data.length; j++) {
          if (this.options.columns[j].data_type == 'code') {
            obj.code[j.toString()] = data[j];
          } else if (this.options.columns[j].data_type == 'valeur') {
            obj.valeur[j.toString()] = data[j];
          } else if (this.options.columns[j].data_type == 'id') {
            obj.id[j.toString()] = data[j];
          }

          obj.row.push(data[j]);
        }
        this.initialValues.push(obj);
      });
    },
    getStructureData: function () {
      for (var i = 0; i < this.options.columns.length; i++) {
        if (this.options.columns[i].title == 'new') {
          this.newColumn = i;
        }
        if (this.options.columns[i].data_type == 'code') {
          this.structureData.code.push(i);
        } else if (this.options.columns[i].data_type == 'valeur') {
          this.structureData.valeur.push(i);
        } else if (this.options.columns[i].data_type == 'id') {
          this.structureData.id.push(i);
        }
      }
    },
    addEmptyLine() {
      var emptyRow = [];
      this.options.columns.forEach((column) => {
        this.columnCount++;
        if (this.dataSet.data.length < 1) {
          if (column.title == 'new') {
            emptyRow.push('true');
          } else {
            emptyRow.push('');
          }
        }
      });
      if (this.dataSet.data.length < 1) {
        this.options.data.push(emptyRow);
      }
    },
    sendData: function (array) {
      if (this.checkUnicite(array)) {
        const cloneInitialValues = this.initialValues.map((object) => ({
          ...object,
        }));
        var objData = new Object();
        objData.insertion = [];
        objData.maj = [];
        objData.suppression = [];
        array.forEach((row) => {
          if (row[this.newColumn] == 'false') {
            var keySlice = 0;
            var count = 0;
            cloneInitialValues.forEach((initialRow) => {
              var objMaj = new Object();
              objMaj.id = [];
              objMaj.valeur = [];

              for (var i = 0; i < this.structureData.id.length; i++) {
                var keyid = this.structureData.id[i];
                if (row[keyid] == '') {
                  objMaj.id.push(-1);
                } else {
                  objMaj.id.push(row[keyid]);
                }
                if (initialRow.row[keyid] != row[keyid]) {
                  break;
                } else {
                  if (i == this.structureData.id.length - 1) {
                    keySlice = count;
                    var flagDiff = false;
                    for (var j = 0; j < this.structureData.valeur.length; j++) {
                      var keyValeur = this.structureData.valeur[j];
                      objMaj.valeur.push(row[keyValeur]);
                      if (initialRow.row[keyValeur] != row[keyValeur]) {
                        flagDiff = true;
                      }
                      if (
                        flagDiff &&
                        j == this.structureData.valeur.length - 1
                      ) {
                        objData.maj.push(objMaj);
                      }
                    }
                  }
                }
              }
              count++;
            });
            if (keySlice != null) {
              cloneInitialValues.splice(keySlice, 1);
            }
          } else {
            var objNewRow = new Object();
            objNewRow.code = [];
            objNewRow.valeur = [];
            for (const [key, value] of Object.entries(this.codeOrder)) {
              if (typeof value != 'number') {
                objNewRow.code.push(value);
              } else {
                objNewRow.code.push(row[value]);
              }
            }
            for (var i = 0; i < this.structureData.valeur.length; i++) {
              var key = this.structureData.valeur[i];
              objNewRow.valeur.push(row[key]);
            }
            objData.insertion.push(objNewRow);
          }
        });
        if (cloneInitialValues.length > 0) {
          for (const [key, value] of Object.entries(cloneInitialValues)) {
            var objDelete = new Object();
            objDelete.id = [];
            for (const [k, v] of Object.entries(value.id)) {
              if (v === '') {
                objDelete.id.push(-1);
              } else {
                objDelete.id.push(v);
              }
            }
            objData.suppression.push(objDelete);
          }
        }
        this.$emit('event-dispatcher', 'json-jexcel', [objData]);
      }
    },
    deleteAllConstraints: function () {
      var objData = new Object();
      objData.insertion = [];
      objData.maj = [];
      objData.suppression = [];
      this.initialValues.forEach((initVal) => {
        var objDelete = new Object();
        objDelete.id = [];
        for (const [key, value] of Object.entries(initVal.id)) {
          if (value == '') {
            objDelete.id.push(-1);
          } else {
            objDelete.id.push(value);
          }
        }
        objData.suppression.push(objDelete);
      });
      this.$emit('event-dispatcher', 'json-jexcel', [objData]);
    },
    openModal: function () {
      this.showModal = true;
    },
    responseModal: function (response) {
      this.showModal = false;
      if (response.confirm == true) {
        this.deleteAllConstraints();
      }
    },
    checkCoherence: function () {
      this.allValueFill = true;
      var k = 0;
      this.spreadsheet.getData().forEach((row) => {
        /* Search match old data */
        var initRow = null;
        if (row[this.newColumn] == 'false') {
          this.initialValues.forEach((rowinit) => {
            for (var i = 0; i < this.structureData.id.length; i++) {
              var keyid = this.structureData.id[i];
              if (rowinit.row[keyid] != row[keyid]) {
                break;
              } else {
                if (i == this.structureData.id.length - 1) {
                  initRow = rowinit.row;
                }
              }
            }
          });
        }

        /* Check blanck code and good existing code line values */
        for (var i = 0; i < this.structureData.code.length; i++) {
          var key = this.structureData.code[i];
          var cellName = jexcel.getColumnNameFromId([key, k]);
          var cellvalue = this.spreadsheet.getValue(cellName);
          if (row[this.newColumn] == 'true') {
            if (cellvalue == '') {
              this.spreadsheet.getCell(cellName).style.backgroundColor = 'red';
              this.allValueFill = false;
            } else {
              this.spreadsheet.getCell(cellName).style.backgroundColor =
                'green';
            }
          }
          if (row[this.newColumn] == 'false') {
            if (cellvalue != initRow[key]) {
              this.allValueFill = false;
              this.spreadsheet.getCell(cellName).style.backgroundColor = 'red';
            } else {
              this.spreadsheet.getCell(cellName).style.backgroundColor =
                'white';
            }
          }
        }
        /* Check blank values */
        for (var j = 0; j < this.structureData.valeur.length; j++) {
          var key = this.structureData.valeur[j];
          var cellName = jexcel.getColumnNameFromId([key, k]);
          var cellvalue = this.spreadsheet.getValue(cellName);
          if (cellvalue === '') {
            this.spreadsheet.getCell(cellName).style.backgroundColor = 'red';
            this.allValueFill = false;
          } else {
            if (
              this.options.columns[key].type == 'numeric' &&
              !this.checkIsNumeric(cellvalue)
            ) {
              this.spreadsheet.getCell(cellName).style.backgroundColor = 'red';
            } else {
              if (row[this.newColumn] == 'false') {
                this.spreadsheet.getCell(cellName).style.backgroundColor =
                  'white';
              } else {
                this.spreadsheet.getCell(cellName).style.backgroundColor =
                  'green';
              }
            }
          }
        }
        k++;
      });
    },
    checkUnicite: function (array) {
      var flagUni = true;
      var error = [];
      var codeColumsArray = [];
      this.options.columns.forEach((row) => {
        if (row.data_type == 'code') {
          codeColumsArray.push(' ' + row.title);
        }
      });

      var i = 0;
      array.forEach((row) => {
        if (row[this.newColumn] == 'true') {
          var j = 0;
          array.forEach((rowCodeU) => {
            if (j != i) {
              var k = 0;
              for (k = 0; k < this.structureData.code.length; k++) {
                var key = this.structureData.code[k];
                if (row[key] != rowCodeU[key]) {
                  break;
                }
                if (k == this.structureData.code.length - 1) {
                  if ((j > i) || rowCodeU[this.newColumn] == 'false') {
                    error.push({ i, j });
                  }
                  flagUni = false;
                }
              }
            }
            j++;
          });
        }
        i++;
      });

      var messageError = '';
      error.forEach((err) => {
        messageError +=
          'La ligne ' +
          (err['i'] + 1) +
          " ne respecte pas l'unicité avec la ligne " +
          (err['j'] + 1) +
          '.\n';
      });
      messageError +=
        "Veuillez vérifier l'unicité sur les colonnes: " +
        codeColumsArray.toString() +
        '.\n';

      if (error.length > 0) {
        this.$emit('event-dispatcher', 'message-response', [
          messageError,
          0,
          true,
          600000,
        ]);
      }

      return flagUni;
    },
    checkIsNumeric(inValue) {
      const pattern = /^([0-9]+(?:[\.][0-9]{1,6})?)$/;
      if (pattern.test(inValue)) {
        return true;
      } else {
        return false;
      }
    },
    dropdownFilter: function (instance, cell, c, r, source) {
      if (Object.keys(this.contraintes).includes(c.toString())) {
        var contraintes = this.contraintes[c.toString()];
        for (var i = 0; i < contraintes.length; i++) {
          var keyDependency = contraintes[i];
          var valueDependency = this.spreadsheet.getRowData(r)[keyDependency];
          if (valueDependency == 'false') {
            for (var k = 0; k < this.initialValues.length; k++) {
              for (var j = 0; j < this.structureData.id.length; j++) {
                var key = this.structureData.id[j];
                if (
                  this.initialValues[k].id[key] !=
                  this.spreadsheet.getRowData(r)[key]
                ) {
                  break;
                } else {
                  if (j == this.structureData.id.length - 1) {
                    return (source = [this.initialValues[k].row[c]]);
                  }
                }
              }
            }
            var cellName = jexcel.getColumnNameFromId([x2, y2]);

            source = [this.spreadsheet.getValue(cellName)];
            return source;
          }

          if (valueDependency == 'true') {
            //does nothing but must pass here
          } else if (valueDependency != '') {
            source = this.sources[c.toString()][valueDependency];
          } else {
            this.$emit('event-dispatcher', 'message-response', [
              'Veuillez renseigner la valeur de la colonne ' +
                this.options.columns[keyDependency].title +
                ' avant celle-ci.',
              0,
              true,
              600000,
            ]);
            source = [];
          }
        }
        return source;
      }
    },
    onChange: function (instance, cell, x, y, value, oldValue) {
      var xcell = cell.getAttribute('data-x');
      var ycell = cell.getAttribute('data-y');
      var row = this.spreadsheet.getRowData(ycell);
      for (const [key, value] of Object.entries(this.contraintes)) {
        if (value.includes(xcell.toString()) && row[this.newColumn] == 'true') {
          var source = this.options.columns[key].source;
          var sourceFiltered = this.dropdownFilter(
            null,
            null,
            key,
            ycell,
            source
          );
          if (sourceFiltered.length == 1) {
            this.spreadsheet.setValueFromCoords(
              key,
              ycell,
              sourceFiltered[0],
              false
            );
          } else {
            this.spreadsheet.setValueFromCoords(key, ycell, '', false);
          }
        }
      }
      this.checkCoherence();
    },
    onInsertRow: function (instance, row) {
      var history = this.spreadsheet.history;
      var historyIndex = this.spreadsheet.historyIndex;
      var insertBefore = history[historyIndex].insertBefore;
      if (!insertBefore) {
        row = row + 1;
      }
      var rowData = this.spreadsheet.getRowData(row);
      rowData[this.newColumn] = 'true';
      this.checkCoherence();
    },
    onDeleteRow: function () {
      this.checkCoherence();
    },
    onPaste: function () {
      this.checkCoherence();
    },
    contextMenuCustom: function (obj, x, y, e) {
      var items = [];

      if (y == null) {
        // Sorting
        if (obj.options.columnSorting == true) {
          items.push({
            title: 'Ordre ascendant',
            onclick: function () {
              obj.orderBy(x, 0);
            },
          });
          items.push({
            title: 'Ordre descendant',
            onclick: function () {
              obj.orderBy(x, 1);
            },
          });
        }
      } else {
        // Insert new row
        if (obj.options.allowInsertRow == true) {
          items.push({
            title: 'Insérer une ligne avant',
            onclick: function () {
              obj.insertRow(1, parseInt(y), 1);
            },
          });

          items.push({
            title: 'Insérer une ligne après',
            onclick: function () {
              obj.insertRow(1, parseInt(y));
            },
          });
        }

        if (obj.options.allowDeleteRow == true) {
          items.push({
            title: 'Supprimer la ligne séléctionnée',
            onclick: function () {
              obj.deleteRow(
                obj.getSelectedRows().length ? undefined : parseInt(y)
              );
            },
          });
        }
      }

      return items;
    },
    undo() {
      this.spreadsheet.undo();
      this.checkCoherence();
    },
    redo() {
      this.spreadsheet.redo();
      this.checkCoherence();
    },
  },
  watch: {
    recherche: function () {
      this.spreadsheet.search(this.recherche);
    },
    widthJexcel: function () {
      this.spreadsheet.content.style.width = this.widthJexcel - 10 + 'px';
    },
    heightJexcel: function () {
      this.spreadsheet.content.style.height = this.heightJexcel - 80 + 'px';
      this.spreadsheet.content.style['min-height'] =
        this.heightJexcel - 80 + 'px';
    },
    spreadsheet: function () {
      this.checkCoherence();
      this.spreadsheet.content.style['min-height'] =
        this.heightJexcel - 80 + 'px';
      this.spreadsheet.content.style['border-style'] = 'solid';
      this.spreadsheet.content.style['border-width'] = '1px';
    },
  },
  mounted() {
    this.el = this.$refs['spreadsheet'];
    (this.options.columns = this.dataSet.columns),
      (this.contraintes = this.dataSet.contraintes);
    this.options.data = this.dataSet.data;
    if (this.conf.addDeleteRow == true) {
      this.options.allowInsertRow = true;
      this.options.allowDeleteRow = true;
    } else {
      this.options.allowInsertRow = false;
      this.options.allowDeleteRow = false;
    }
    this.codeOrder = this.dataSet.codeOrder;
    this.allowDelteAllContraints = this.dataSet.data.length;
    this.options.columns.forEach((column) => {
      if (Object.keys(column).includes('filter')) {
        column.filter = this.dropdownFilter;
      }
    });
    this.options.tableWidth = this.widthJexcel - 10 + 'px';
    this.options.tableHeight = this.heightJexcel - 80 + 'px';

    if (this.dataSet.data.length < 1) {
      this.addEmptyLine();
    }
    this.spreadsheet = jexcel(this.el, this.options);
    this.getStructureData();
    this.keepInitialRows();
  },
};
</script>
<style style lang="scss" scoped>
input {
  border: 1px solid black;
}
.v-text-field {
  padding-left: 10px;
}

.fix-btn-margin-top {
  margin-top: 10px;
}

.jdropdown-container {
  z-index: 10 !important;
}
</style>
